// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mwXdZ","rootNoMargin":"styles_rootNoMargin__9nbJi"};